import createStatusChipIndicator from '@/components/statuses/factory/createStatusChipIndicator';

import TALENT_SESSION_STATUSES from './options';

const TalentStatus = createStatusChipIndicator({
  prefix: 'talent',
  options: TALENT_SESSION_STATUSES,
  defaultSx: ({ applyDirectionalStyles }) => ({
    '&.IndicatorChip-root': {
      borderColor: 'transparent'
    },
    '&.IndicatorChip-root.IndicatorChip-clickable:hover': {
      bgcolor: 'primary.200'
    },
    '&.IndicatorChip-root.Mui-selected': {
      borderColor: 'primary.main'
    },
    '&.IndicatorChip-root.Mui-selected.IndicatorChip-clickable:hover': {
      borderColor: 'primary.main'
    },
    '& .MuiChip-icon': applyDirectionalStyles(0.625, -0.75, 'ml', 'mr'),
    '& .MuiChip-label': {
      color: 'text.primary'
    },
    '&.IndicatorChip-root.IndicatorChip-clickable:hover .MuiChip-label': {
      color: 'text.primary'
    }
  }),
  translationNamespace: 'filters'
});

export default TalentStatus;
